import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccStockRateCourt = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.STOCKS_RATE_COURT',
  });
  return result;
};
